(() => {
  function init(root) {
    const calendar = root.closest('[data-upupa-cal]');
    const api = window.UPUPA_TILAUS;
    if (!calendar || !api || root.dataset.ready) return;
    const data = JSON.parse(root.querySelector('[data-flex-data]').textContent);
    const labels = data.labels;
    const staff = api.staffData() || { variants: [], coffee: [] };
    const standardCoffee = (staff.coffee || []).filter(v => v.title.includes('250 ml'));
    const money = value => new Intl.NumberFormat(data.locale, { style: 'currency', currency: data.currency || 'EUR' }).format(value / 100);
    const coffeeText = v => labels[({ '59142992625996':'coffee_black', '59142992658764':'coffee_milk', '59142992691532':'coffee_oat' })[String(v.id)]] || v.title;
    let iso = '';
    root.dataset.ready = 'true';
    const states = Array.from(root.querySelectorAll('[data-flex-mode]')).map(card => {
      const form = card.querySelector('[data-flex-form]');
      const state = {
        card, form, mode: card.dataset.flexMode, busy: false, locked: false,
        main: form.querySelector('[data-flex-main]'), soup: form.querySelector('[data-flex-soup]'),
        mainQty: form.querySelector('[data-flex-main-qty]'), soupQty: form.querySelector('[data-flex-soup-qty]'), coffee: form.querySelector('[data-flex-coffee]'),
        button: form.querySelector('[data-flex-add]'), message: form.querySelector('[data-flex-message]')
      };
      if (state.coffee) {
        const blank = new Option(labels.choose, ''); blank.disabled = true; blank.selected = true;
        state.coffee.append(blank);
        standardCoffee.filter(v => v.available).forEach(v => state.coffee.append(new Option(coffeeText(v), String(v.id))));
      }
      card.querySelector('[data-flex-calendar]').addEventListener('click', () => {
        const picker = calendar.querySelector('[data-date-switch]');
        if (picker) picker.open = true;
        const target = calendar.querySelector('.upupa-day[aria-pressed="true"]') || calendar.querySelector('.upupa-day:not(:disabled)');
        target?.focus();
        target?.scrollIntoView({ block: 'center', behavior: 'auto' });
      });
      form.addEventListener('input', () => { if (!state.locked) state.message.textContent = ''; update(state); });
      form.addEventListener('change', () => { if (!state.locked) state.message.textContent = ''; update(state); });
      form.addEventListener('submit', event => submit(event, state));
      card.querySelector('[data-flex-enhanced]').hidden = false;
      return state;
    });
    function eligible(product, state, date = iso) {
      return (state.mode !== 'care' || product.care) && !api.dateProblem(product.handle, date) && product.variants.some(v => v.available);
    }
    function entries(state, group) {
      return data.products.filter(p => p.group === group && eligible(p, state)).flatMap(product => product.variants.filter(variant => variant.available).map(variant => ({ product, variant })));
    }
    function optionText(entry) {
      return entry.product.title + (entry.variant.title === 'Default Title' ? '' : ' · ' + entry.variant.title) + ' · ' + money(entry.variant.price);
    }
    function populate(state, group, preserve = false) {
      const select = state[group];
      const oldValue = preserve ? select.value : '';
      const items = entries(state, group);
      select.replaceChildren();
      const placeholder = new Option(group === 'main' ? labels.choose : labels.no_soup, '');
      placeholder.disabled = group === 'main';
      select.append(placeholder);
      items.forEach(entry => select.append(new Option(optionText(entry), String(entry.variant.id))));
      select.value = items.some(entry => String(entry.variant.id) === oldValue) ? oldValue : '';
    }
    function selection(state) {
      return ['main', 'soup'].map(group => {
        const id = state[group].value;
        if (!id) return null;
        const entry = entries(state, group).find(entry => String(entry.variant.id) === id);
        return entry ? { ...entry, quantity: Number(state.mode === 'staff' ? state.mainQty.value : state[group + 'Qty'].value) } : null;
      }).filter(Boolean);
    }
    function staffVariant(state) {
      const sku = 'UPUPA-STAFF-' + state.main.value + '-' + (state.soup.value || '0');
      return (staff.variants || []).find(v => v.sku === sku);
    }
    function update(state) {
      const chosen = selection(state);
      let valid = !!state.main.value && chosen.some(x => x.product.group === 'main') && chosen.every(x => Number.isSafeInteger(x.quantity) && x.quantity > 0 && !api.dateProblem(x.product.handle, iso));
      const unitRegular = chosen.reduce((total, item) => total + item.variant.price, 0);
      const bundle = state.mode === 'staff' ? staffVariant(state) : null;
      const pricingOk = !!bundle?.available && bundle.price === Math.round(unitRegular * .8);
      if (state.mode === 'staff') {
        valid = valid && pricingOk && standardCoffee.some(v => String(v.id) === state.coffee.value && v.available);
        state.coffee.disabled = state.busy;
        state.form.querySelector('[data-flex-regular]').textContent = money(unitRegular * (Number.isSafeInteger(Number(state.mainQty.value)) && Number(state.mainQty.value) > 0 ? Number(state.mainQty.value) : 0));
        if (state.main.value && !pricingOk && !state.locked) state.message.textContent = labels.staff_unavailable;
      }
      state.valid = valid;
      state.button.disabled = state.busy || state.locked || !valid;
      state.button.textContent = state.busy ? labels.adding : labels.add;
      state.main.disabled = state.busy || !entries(state, 'main').length;
      state.mainQty.disabled = state.busy;
      state.soup.disabled = state.busy || !entries(state, 'soup').length;
      if (state.soupQty) state.soupQty.disabled = state.busy || !state.soup.value;
      const sum = chosen.reduce((total, x) => total + (Number.isSafeInteger(x.quantity) && x.quantity > 0 ? x.variant.price * x.quantity : 0), 0);
      state.form.querySelector('[data-flex-total]').textContent = money(state.mode === 'staff' ? (pricingOk && Number.isSafeInteger(Number(state.mainQty.value)) && Number(state.mainQty.value) > 0 ? bundle.price * Number(state.mainQty.value) : 0) : sum);
      const info = state.form.querySelector('[data-flex-food-info]');
      info.replaceChildren();
      chosen.forEach(({ product }) => {
        const p = document.createElement('p');
        const link = document.createElement('a');
        link.href = product.url; link.textContent = product.title;
        p.append(link);
        const details = document.createElement('p');
        details.textContent = product.description;
        info.append(p, details);
      });
    }
    function render(date) {
      if (!date || date === iso) return;
      iso = date;
      states.forEach(state => {
        populate(state, 'main'); populate(state, 'soup');
        state.card.querySelector('[data-flex-date]').textContent = api.longLabel(api.isoToUtc(iso));
        const empty = state.card.querySelector('[data-flex-empty]');
        empty.hidden = entries(state, 'main').length > 0;
        const next = state.card.querySelector('[data-flex-next]');
        next.removeAttribute('href'); next.textContent = '';
        if (!empty.hidden) {
          const windowDates = api.orderWindow();
          for (let u = windowDates.first; u <= windowDates.last; u += 86400000) {
            const candidate = api.utcToIso(u);
            if (candidate <= iso || !data.products.some(p => p.group === 'main' && eligible(p, state, candidate))) continue;
            const url = new URL(window.location.href);
            url.searchParams.set('pvm', candidate); url.searchParams.set('meal', state.mode); url.hash = 'ateriat-arkeen';
            next.href = url.href; next.textContent = labels.next + ': ' + api.longLabel(u); break;
          }
        }
        if (!state.locked) state.message.textContent = '';
        update(state);
      });
    }
    async function submit(event, state) {
      event.preventDefault();
      if (state.busy || state.locked) return;
      update(state);
      if (!state.valid || !state.form.reportValidity()) { state.message.textContent = labels.invalid; return; }
      const chosen = selection(state);
      const requestedIso = iso;
      state.busy = true; state.message.textContent = ''; update(state);
      let posted = false;
      try {
        const fresh = await Promise.all(chosen.map(async item => {
          const response = await fetch(item.product.url + '.js', { credentials: 'same-origin', cache: 'no-store' });
          if (!response.ok) throw new Error('price check failed');
          const product = await response.json();
          return product.variants.find(v => String(v.id) === String(item.variant.id));
        }));
        let changed = false;
        chosen.forEach((item, i) => {
          const variant = fresh[i];
          if (!variant || !variant.available || variant.price !== item.variant.price) changed = true;
          item.variant.available = !!variant?.available;
          if (variant) item.variant.price = variant.price;
        });
        if (requestedIso !== iso || chosen.some(item => api.dateProblem(item.product.handle, requestedIso))) {
          state.message.textContent = labels.invalid; state.busy = false; update(state); return;
        }
        if (changed) {
          populate(state, 'main', true); populate(state, 'soup', true);
          state.message.textContent = labels.changed; state.busy = false; update(state); return;
        }
        let items = chosen.map(item => ({
          id: item.variant.id, quantity: item.quantity,
          properties: { _pvm: requestedIso, [data.dateLabel]: api.propLabel(api.isoToUtc(requestedIso)) }
        }));
        if (state.mode === 'staff') {
          const bundle = staffVariant(state);
          const [bundleResponse, coffeeResponse] = await Promise.all([fetch(staff.url + '.js', { credentials: 'same-origin', cache: 'no-store' }), fetch(staff.coffeeUrl + '.js', { credentials: 'same-origin', cache: 'no-store' })]);
          if (!bundleResponse.ok || !coffeeResponse.ok) throw new Error('staff validation failed');
          const currentBundle = (await bundleResponse.json()).variants.find(v => v.id === bundle.id);
          const currentCoffee = (await coffeeResponse.json()).variants.find(v => String(v.id) === state.coffee.value);
          const unitRegular = chosen.reduce((total, item) => total + item.variant.price, 0);
          if (!currentBundle?.available || currentBundle.price !== Math.round(unitRegular * .8) || !currentCoffee?.available || !currentCoffee.title.includes('250 ml')) {
            if (currentBundle) Object.assign(bundle, currentBundle);
            state.message.textContent = labels.staff_unavailable; state.busy = false; update(state); return;
          }
          if (iso !== requestedIso || chosen.some(item => api.dateProblem(item.product.handle, requestedIso))) {
            state.message.textContent = labels.invalid; state.busy = false; update(state); return;
          }
          items = [{
            id: currentBundle.id, quantity: Number(state.mainQty.value),
            properties: {
              _pvm: requestedIso, [data.dateLabel]: api.propLabel(api.isoToUtc(requestedIso)),
              _upupa_coffee_variant: String(currentCoffee.id),
              [data.coffeeLabel]: '1 × Lehmus Pusupuisto · ' + coffeeText(currentCoffee)
            }
          }];
        }
        posted = true;
        const response = await fetch(data.rootUrl.replace(/\/?$/, '/') + 'cart/add.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!response.ok) throw new Error('cart addition failed');
        window.location.href = data.cartUrl;
      } catch (error) {
        state.locked = posted; state.busy = false;
        state.message.textContent = labels.error;
        state.form.querySelector('[data-flex-review]').hidden = false;
        update(state);
      }
    }
    calendar.addEventListener('upupa:daychange', event => render(event.detail.iso));
    const selectedDay = calendar.querySelector('.upupa-day[aria-pressed="true"]');
    const initial = selectedDay ? api.utcToIso(Number(selectedDay.dataset.u)) : calendar.querySelector('[data-el="menu"] [data-upupa-iso]')?.value;
    render(initial);
    const requestedMode = new URLSearchParams(window.location.search).get('meal');
    states.find(state => state.mode === requestedMode)?.card.setAttribute('open', '');
  }
  function scan() { document.querySelectorAll('[data-flex-meals]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true }); else scan();
  window.addEventListener('load', scan, { once: true });
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('upupa:daychange', scan);
})();